import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Loader2, Send, Users } from "lucide-react";
import { toast } from "sonner";

export function BulkSignoffInvite({ onDone }) {
  const [emails, setEmails] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post("/me/policies/signoff-requests/bulk", { emails: emails.split(/[\s,;]+/).filter(Boolean), message });
      setResult(data); setEmails(""); setMessage("");
      toast.success(`Invites sent to ${data.sent.length} staff · ${data.requests_created} sign-off requests created`);
      onDone?.();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Could not send"); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl border border-border bg-card p-5 mb-6" data-testid="bulk-signoff-invite">
      <p className="font-display font-semibold flex items-center gap-2"><Users className="w-4 h-4 text-accent" /> Invite your whole team in one go</p>
      <p className="text-xs text-muted-foreground mt-1 mb-3">Paste your staff list once. Each person gets a single email with a personal link listing every policy in your pack to read and sign — anyone who has already signed a policy is skipped.</p>
      <form onSubmit={submit} className="grid sm:grid-cols-[1fr_auto] gap-2">
        <Textarea rows={3} required placeholder="jo@example.org, sam@example.org — commas, spaces or one per line (up to 100)" value={emails} onChange={(e) => setEmails(e.target.value)} className="sm:row-span-2" data-testid="bulk-signoff-emails" />
        <Input placeholder="Optional note to staff" value={message} onChange={(e) => setMessage(e.target.value)} data-testid="bulk-signoff-message" />
        <Button type="submit" disabled={busy} data-testid="bulk-signoff-send">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Send className="w-4 h-4 mr-1.5" /> Send to team</>}</Button>
      </form>
      {result && (
        <p className="text-xs mt-3 text-muted-foreground" data-testid="bulk-signoff-result">
          Sent to {result.sent.length} · {result.requests_created} new requests across {result.policies} policies{result.failed.length ? ` · could not email: ${result.failed.join(", ")}` : ""}
        </p>
      )}
    </div>
  );
}
